import axios from 'axios';
import _ from 'lodash';

export default {
  fetchProductItems(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+'/api/latest/admin/product-items', {params})
      .then(res => res && res.data);
  },
  getProductItem(productItemId){
      return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+'/api/latest/admin/product-items/'+productItemId)
      .then(res => res && res.data);

  },
  downloadTechnicalSheetPdf (productItemId, filename = 'fiche-technique.pdf', puid = null, technicalSheetTemplate = null, customerClassId = null) {
    const params = {};
    if (puid != null) params.puid = puid;
    if (technicalSheetTemplate != null) params.technicalSheetTemplate = technicalSheetTemplate;
    if (customerClassId != null) params.customerClassId = customerClassId;

    return axios({
      url: process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/api/latest/admin/product-items/${productItemId}/report`,
      method: 'GET',
      responseType: 'blob',
      params: _.isEmpty(params) ? undefined : params,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    });
  }
}
